import React from 'react';
import { Banknote, Zap, Bus, AlertTriangle, Phone, Coins } from 'lucide-react';
import { S } from '../constants';

export const InfoCards = ({ cityInfo, t, loading }) => {
  const stdItems = [
    {k:'currency',  icon:Banknote,      c:'#1976d2', bg:'#e3f2fd'},
    {k:'voltage',   icon:Zap,           c:'#f57c00', bg:'#fff3e0'},
    {k:'transport', icon:Bus,           c:'#388e3c', bg:'#e8f5e9'},
    {k:'tips',      icon:AlertTriangle, c:'#c62828', bg:'#ffebee'},
    {k:'tipping',   icon:Coins,         c:'#7c3aed', bg:'#ede9fe'},
  ];

  const em = cityInfo?.emergency;
  const al = t.aiLang||'';
  const isTrad = al==='Traditional Chinese', isSim = al==='Simplified Chinese', isJp = al==='Japanese', isKo = al==='Korean';
  const emLabels = {
    police:   isTrad?'警察':isSim?'警察':isJp?'警察':isKo?'경찰':'Police',
    ambulance:isTrad?'救護':isSim?'救护':isJp?'救急':isKo?'구급':'Ambulance',
    fire:     isTrad?'消防':isSim?'消防':isJp?'消防':isKo?'소방':'Fire',
    other:    isTrad?'其他':isSim?'其他':isJp?'その他':isKo?'기타':'Other',
  };
  const emLines = em && typeof em === 'object'
    ? [
        em.police    && { label:emLabels.police,    val:String(em.police)   },
        em.ambulance && { label:emLabels.ambulance,  val:String(em.ambulance)},
        em.fire      && { label:emLabels.fire,       val:String(em.fire)     },
        em.other     && { label:emLabels.other,      val:String(em.other)    },
      ].filter(Boolean)
    : em
      ? [{ label:'', val:String(em) }]
      : null;

  return (
    <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:10 }}>
      {stdItems.map(({k,icon:Ic,c,bg})=>(
        <div key={k} style={{ ...S.card, padding:'14px 16px', display:'flex', alignItems:'flex-start', gap:12 }}>
          <div style={{ width:36,height:36,background:bg,borderRadius:10,display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0,marginTop:2 }}>
            <Ic size={16} color={c}/>
          </div>
          <div style={{ flex:1, minWidth:0 }}>
            <p style={{ fontSize:10,fontWeight:900,textTransform:'uppercase',letterSpacing:1.5,color:'#64748b',margin:'0 0 4px' }}>{t[k]||k}</p>
            {loading
              ? <><div style={S.skel(11,'90%')}/><div style={{ ...S.skel(10,'65%'),marginTop:4 }}/></>
              : <p style={{ fontSize:12,fontWeight:700,color:'#334155',margin:0,lineHeight:1.6,wordBreak:'break-word' }}>{
                  (() => { const v=cityInfo?.[k]; if(!v) return '—'; if(typeof v==='object') return Object.values(v).filter(x=>typeof x==='string').join(' · ')||'—'; return v; })()
                }</p>
            }
          </div>
        </div>
      ))}

      <div style={{ ...S.card, padding:'14px 16px', display:'flex', alignItems:'flex-start', gap:12 }}>
        <div style={{ width:36,height:36,background:'#f3e5f5',borderRadius:10,display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0,marginTop:2 }}>
          <Phone size={16} color="#7b1fa2"/>
        </div>
        <div style={{ flex:1, minWidth:0 }}>
          <p style={{ fontSize:10,fontWeight:900,textTransform:'uppercase',letterSpacing:1.5,color:'#64748b',margin:'0 0 6px' }}>{t.emergency||'緊急電話'}</p>
          {loading
            ? <><div style={S.skel(11,'80%')}/><div style={{ ...S.skel(10,'70%'),marginTop:4 }}/><div style={{ ...S.skel(10,'75%'),marginTop:4 }}/></>
            : emLines
              ? <div style={{ display:'flex', flexDirection:'column', gap:4 }}>
                  {emLines.map((line,i)=>(
                    <div key={i} style={{ display:'flex', alignItems:'flex-start', gap:6, flexWrap:'wrap' }}>
                      {line.label && <span style={{ fontSize:10,fontWeight:900,color:'#7b1fa2',background:'#f3e5f5',padding:'1px 6px',borderRadius:6,flexShrink:0,marginTop:2 }}>{line.label}</span>}
                      <span style={{ fontSize:13,fontWeight:900,color:'#1e293b',letterSpacing:0.5,wordBreak:'break-word',flex:1,minWidth:0 }}>{line.val}</span>
                    </div>
                  ))}
                </div>
              : <p style={{ fontSize:12,fontWeight:700,color:'#334155',margin:0 }}>—</p>
          }
        </div>
      </div>

      <div style={{ ...S.card, padding:'14px 16px', display:'flex', alignItems:'flex-start', gap:12 }}>
        <div style={{ width:36,height:36,background:'#fce4ec',borderRadius:10,display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0,marginTop:2 }}>
          <AlertTriangle size={16} color="#b71c1c"/>
        </div>
        <div style={{ flex:1, minWidth:0 }}>
          <p style={{ fontSize:10,fontWeight:900,textTransform:'uppercase',letterSpacing:1.5,color:'#64748b',margin:'0 0 4px' }}>{t.taboos||'禁忌須知'}</p>
          {loading
            ? <><div style={S.skel(11,'90%')}/><div style={{ ...S.skel(10,'65%'),marginTop:4 }}/></>
            : <p style={{ fontSize:12,fontWeight:700,color:'#334155',margin:0,lineHeight:1.6,wordBreak:'break-word' }}>{cityInfo?.taboos||'—'}</p>
          }
        </div>
      </div>
    </div>
  );
};
